export { default as useToggleMaterialFavorite } from './useToggleMaterialFavorite';
